
import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import Grid from '../../../../common/CustomGrid';
//import image from '../../../../../assets/images/soluciones_aereos.png'; 
import { Box, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import AOS from 'aos';
import RawMarkup from '../../../../common/RawMarkup'

import Preloader from '../../../../common/Preloader'; 

export default function SolutionSectionItem(data = {}) {

    useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    if (!data) {
        console.error("Error: Datos no disponibles para SolutionsSection.");
        return (
            <Preloader />
        );
    }

    const { title ="", description ="", slug="", url="#", image = []  } = data.data;

    const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:1337";
    const imageUrl = image?.url  ? `${baseUrl}${image.url}`   : ""; 

    const Image = () => <Box data-aos="fade-left" className='absolute-image' component="img" src={imageUrl} alt={title} />

    return (
        <>
            <Grid className="solution-section" container spacing={4} alignItems="center" sx={{py:{xs: 4, md: 8}}}>
                <Grid size={{ xs: 12, md: 6 }}>
                    {title && <Typography data-aos="fade-up" className='solutions_section-title' variant="h4" >
                    {isDesktop && <span className={`icon icon-${slug}`}></span>}  {title}
                    </Typography>}

                    {description && <Typography data-aos="fade-up" className='solutions_section-text' sx={{ mb: 4 }}>
                        <RawMarkup content={description} />
                    </Typography>}  

                    {url && <Button data-aos="fade-up" variant="contained" color="primary" component={Link} to={url} >
                        Conoce Más
                    </Button>}  

                </Grid>            
            </Grid>
            {isDesktop && <Image /> }
        </>
    )
}
